import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { CompanyTrustRequestor } from 'src/app/models/CompanyTrustRequestor';

@Injectable({
    providedIn: 'root'
})
export class CompanyTrustRequestorApi extends Api<CompanyTrustRequestor> {
}
